/* eslint-disable unicorn/no-useless-undefined */ import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { useState, useEffect } from "react";
import { isEmpty } from "lodash";
import { targetActivities } from "./constants";
function getActivityId(activityConst) {
    var activityId = targetActivities[activityConst];
    if (typeof activityId === "undefined") {
        // eslint-disable-next-line no-console
        console.warn("Activity ID: ".concat(activityConst, " is missing from targetActivities in packages/hooks/target/src/constants.ts"));
    }
    return activityId;
}
function getTargetPropertyFromWindow() {
    return "object" === "undefined" ? undefined : window["ttMETA"];
}
var getTargetActivity = function(activityId) {
    var ref;
    var targetActivity = (ref = getTargetPropertyFromWindow()) === null || ref === void 0 ? void 0 : ref.find(function(activity) {
        return activity.ActivityId === activityId;
    });
    if (!isEmpty(targetActivity)) {
        return targetActivity;
    }
    return undefined;
};
var useAdobeTarget = function(activityConst) {
    var targetTimeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3000;
    var activityId = getActivityId(activityConst);
    var ref = useState(function() {
        var ref;
        if ((ref = getTargetPropertyFromWindow()) === null || ref === void 0 ? void 0 : ref.length) {
            return getTargetActivity(activityId);
        }
        return undefined;
    }), activityData = ref[0], setActivityData = ref[1];
    useEffect(function() {
        var didCancel = false;
        // Apply a timeout of 3 seconds to windowMonitor()
        var windowMonitorTimeout = timeoutPromise(targetTimeout, windowMonitor());
        var setActivityDataIfMounted = function(value) {
            return didCancel || setActivityData(value);
        };
        // Wait for promise resolve
        windowMonitorTimeout.then(function() {
            var ref;
            if ((ref = getTargetPropertyFromWindow()) === null || ref === void 0 ? void 0 : ref.length) {
                var ref1;
                return setActivityDataIfMounted((ref1 = getTargetActivity(activityId)) !== null && ref1 !== void 0 ? ref1 : null);
            }
            // eslint-disable-next-line no-console
            console.log("".concat(activityConst, " - ").concat(activityId, " not found"));
            setActivityDataIfMounted(null);
        }).catch(function(error) {
            // eslint-disable-next-line no-console
            console.log(error);
            setActivityDataIfMounted(null);
        });
        windowMonitorTimeout.catch(function(error) {
            // eslint-disable-next-line no-console
            console.log(error);
            setActivityData(null);
        });
        return function() {
            didCancel = true;
        };
    }, [
        activityConst
    ]);
    return activityData;
};
//   // Handle timeout by racing passed in promise against setTimeout
var timeoutPromise = function(ms, promise) {
    // Create a promise that rejects in <ms> milliseconds
    var timeout = new Promise(function(_, reject) {
        var id = setTimeout(function() {
            clearTimeout(id);
            reject("Timed out in ".concat(ms, "ms."));
        }, ms);
    });
    // Return race between timeout and passed in promise
    return Promise.race([
        promise,
        timeout
    ]);
};
//   // Async monitor window obj for target response tokens
var windowMonitor = function() {
    var _ref = _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!getTargetPropertyFromWindow()) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        new Promise(function(resolve) {
                            return setTimeout(resolve, 0);
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        0
                    ];
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return function windowMonitor() {
        return _ref.apply(this, arguments);
    };
}();
export default useAdobeTarget;
